const { Text } = require("@chakra-ui/react");

const BankDetailsWithProvidedData = ({bankDetails}) => {

  return (
    <>
      {bankDetails && (
        <div className="bank-details-container">
          <Text className="fw-600">Bank Account Information:</Text>
          <Text className="terms-text">
            {bankDetails?.bankName} - {bankDetails?.branchName}
          </Text>
          <Text className="terms-text">
            Account Number: {bankDetails?.accountNumber}, IFSC: {bankDetails?.ifsc}
          </Text>
        </div>
      )}
    </>
  );
};

export default BankDetailsWithProvidedData;
